export default __webpack_public_path__ + "static/continuous-integration-1-826979d08721992f461f50b75c39a7e1.png";